export default "__VITE_ASSET__BrLgPfN6__"